import { FC, ReactElement, useCallback } from 'react';
import { IWebhookRequestParam, IWebhookRequestParamValidation } from '../../../../types/webhooks';
import { localeStore } from '~/mobx/localesStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import DeleteRestoreBlock from '~/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import './style.scss';

interface IProps {
  param: IWebhookRequestParam;
  validation: IWebhookRequestParamValidation | undefined;
  deleteParam: (id: number) => void;
  editParam: (param: IWebhookRequestParam) => void;
}

const WebhookParameter: FC<IProps> = ({ param, validation, ...props }: IProps): ReactElement => {
  const onEditParam = (field: keyof IWebhookRequestParam) => (value: string | undefined) => {
    props.editParam({ ...param, [field]: value });
  };

  const onDeleteParam = useCallback(() => {
    props.deleteParam(param.frontId);
  }, [param.frontId]);

  return (
    <li className="webhook-parameter">
      <Input
        value={param.key}
        onChangeValue={onEditParam('key')}
        validation={validation?.key}
        placeholder={localeStore.t('key')}
        className="flex-1"
        contentClassName="webhook-parameter__input"
      />
      <Input
        value={param.value}
        onChangeValue={onEditParam('value')}
        validation={validation?.value}
        placeholder={localeStore.t('Value')}
        className="flex-1"
        contentClassName="webhook-parameter__input"
      />
      <DeleteRestoreBlock onDelete={onDeleteParam} iconClassName="mt-2" />
    </li>
  );
};

export default WebhookParameter;
